import React from "react";

const HUMANIZE = (s) => String(s).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const ReportTableBlock = ({ table }) => {
  if (!table?.rows?.length) {
    return (
      <div className="rounded-xl border border-dashed border-slate-200 bg-slate-50 p-6 text-center">
        <h3 className="text-sm font-semibold text-slate-700">{table?.title || "Table"}</h3>
        <p className="text-xs text-slate-500 mt-1">No rows match the current filters.</p>
      </div>
    );
  }
  const cols = table.columns || Object.keys(table.rows[0] || {});
  return (
    <div data-testid={`report-table-${(table.title || "").replace(/\s/g, "-").toLowerCase()}`} className="rounded-xl border border-slate-200 bg-white overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-200 bg-slate-50/50">
        <h3 className="text-sm font-semibold text-slate-800">{table.title}</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              {cols.map((c) => (
                <th
                  key={c}
                  className="text-left px-4 py-2.5 text-[11px] uppercase tracking-wider font-semibold text-slate-600"
                >
                  {HUMANIZE(c)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((r, i) => (
              <tr key={i} className="border-b last:border-b-0 border-slate-100 hover:bg-slate-50/60">
                {cols.map((c) => (
                  <td key={c} className="px-4 py-2.5 text-slate-700 tabular-nums">
                    {r[c] === null || r[c] === undefined || r[c] === ""
                      ? <span className="text-slate-400">—</span>
                      : typeof r[c] === "number"
                        ? r[c].toLocaleString()
                        : String(r[c])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportTableBlock;
